var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2524 14.909C35.5453 15.2019 35.5453 15.6768 35.2524 15.9697L33.6881 17.534L30.6881 14.534L32.2524 12.9697C32.5453 12.6768 33.0202 12.6768 33.3131 12.9697L35.2524 14.909Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6274 18.5947L29.6274 15.5947L19.4079 25.8141C19.3256 25.8965 19.2636 25.9968 19.2267 26.1073L18.0199 29.7278C17.9222 30.021 18.2011 30.2999 18.4942 30.2022L22.1148 28.9953C22.2252 28.9585 22.3256 28.8965 22.4079 28.8141L32.6274 18.5947Z",
    fill: "#0923E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 32.25C13.5 33.4926 14.5074 34.5 15.75 34.5H32.25C33.4926 34.5 34.5 33.4926 34.5 32.25V23.25C34.5 22.8358 34.1642 22.5 33.75 22.5C33.3358 22.5 33 22.8358 33 23.25V32.25C33 32.6642 32.6642 33 32.25 33H15.75C15.3358 33 15 32.6642 15 32.25V15.75C15 15.3358 15.3358 15 15.75 15H25.5C25.9142 15 26.25 14.6642 26.25 14.25C26.25 13.8358 25.9142 13.5 25.5 13.5H15.75C14.5074 13.5 13.5 14.5074 13.5 15.75V32.25Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.862ed78b1c99bc9961334b1d4b2f6f33.svg";
export { ForwardRef as ReactComponent };